import { render, staticRenderFns } from "./points-orders.vue?vue&type=template&id=bb978b84"
import script from "./points-orders.vue?vue&type=script&lang=js"
export * from "./points-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports